import { useSelector } from 'react-redux';

import { IState } from '../reducers/metadata';
import { getMetadata } from '../selectors/metadata';

export function useMetadata(pathname: string): IState['data'] {
  return useSelector(getMetadata(pathname));
}
